module.exports = __webpack_public_path__ + "img/p5.ee25e807.png";